module.exports = __webpack_public_path__ + "img/product4.b2daf1dd.png";